// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3sqGx","head":"Table_head__3CPeP","col":"Table_col__NHZio"};